import type { TreeInstance } from '@headless-tree/core';


export function defaultHotKeyConfig<T = any>() {
  return {
    focusNextItem: {
      hotkey: 'ArrowDown',
      preventDefault: true,
      handler: (e: KeyboardEvent, tree: TreeInstance<T>) => {
        const focusedItem = tree.getItems().find(item => item.isFocused());
        if (focusedItem) {
          const nextItem = focusedItem.getItemBelow();
          if (nextItem) {
            tree.setSelectedItems([nextItem.getItemMeta().itemId]);
            nextItem.setFocused();
          }
        } else {
          tree.focusNextItem();
        }
      },
    },
    focusPreviousItem: {
      hotkey: 'ArrowUp',
      preventDefault: true,
      handler: (e: KeyboardEvent, tree: TreeInstance<T>) => {
        const focusedItem = tree.getItems().find(item => item.isFocused());
        if (focusedItem) {
          const previousItem = focusedItem.getItemAbove();
          if (previousItem) {
            tree.setSelectedItems([previousItem.getItemMeta().itemId]);
            previousItem.setFocused();
          }
        } else {
          tree.focusPreviousItem();
        }
      },
    },
  };
}
